import { inject, Injectable } from '@angular/core';
import { HttpGatewayService } from './http-gateway.service';
import { Observable, Observer, map } from 'rxjs';
import { ApplicationStore, ApplicationStoreType } from '../store/application.store';
import { SignedInUser, SignedInUserContract } from '../../shared/types/user';

export const USER_URLS = {
    GET_USER: 'api/user',
};

@Injectable({ providedIn: 'root' })
export class UserService {
    private httpGateWayService = inject(HttpGatewayService);
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    public loadUser(forceRefresh: boolean = false): Observable<SignedInUser | null> {
        return new Observable((observer: Observer<SignedInUser | null>) => {
            const currentUser = this.applicationStore.signedInUser();
            if (forceRefresh || !currentUser) {
                this.getSignedInUser().subscribe({
                    next: (user) => {
                        this.applicationStore.setSignedInUser(user);
                        observer.next(user);
                        observer.complete();
                    },
                    error: (error) => {
                        observer.next(null);
                        observer.complete();
                    },
                });
            } else {
                observer.next(currentUser);
                observer.complete();
            }
        });
    }

    private getSignedInUser(): Observable<SignedInUser> {
        return this.httpGateWayService
            .get<SignedInUserContract>(USER_URLS.GET_USER)
            .pipe(
                map(
                    (user) =>
                        new SignedInUser(
                            user.id,
                            user.username,
                            user.firstName,
                            user.lastName,
                            user.email,
                            user.fullName,
                            user.active,
                            user.department,
                        ),
                ),
            );
    }
}
